module.exports = __webpack_public_path__ + "img/dynamic_big1.eead2775.png";